import cssVariables from 'tfs.css-variables'

import staticData from '../../config/staticData'

export default {
  login: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    width: '33rem',
    margin: 'calc(50vh - 9rem) auto',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0.187rem 0.5rem 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: cssVariables.colorWhite,
    padding: '1.4rem',
    borderRadius: '0.5rem'
  },
  transaviaLogo: {
    backgroundImage: `url(${staticData.logoUrl})`,
    width: '200px',
    height: '200px',
    position: 'absolute',
    top: '-210px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    opacity: '.9',
  }
}
